import { useEffect, useState } from "react";
import { IContactusContainerProps } from "./Contactus.interfaces";
import ContactusView from "./Contactus.view";
import BroswerService from "../../Services/Browser.service";
export default function ContactusContainer(props: IContactusContainerProps) {
    useEffect(() => {
        BroswerService.setCustomTitle("ContactusContainer");
    }, []);
    const [showDemo, setShowDemo] = useState(false);
    const demoController = () => setShowDemo(!showDemo);
    return (
        <>
            <ContactusView
                demoController={demoController}
                showDemo={showDemo}
            />
        </>
    );
}
